/* global dataLayer */
import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { CSSTransition, TransitionGroup } from 'react-transition-group'
import classNames from 'classnames'

import styles from './tooltip.css'

class Tooltip extends PureComponent {
  constructor (props) {
    super(props)
    this.state = { active: false }
    this.handleMouseEnter = this.handleMouseEnter.bind(this)
    this.handleMouseLeave = this.handleMouseLeave.bind(this)
    this.handleClick = this.handleClick.bind(this)
  }

  render () {
    const { trigger, children, style, className } = this.props
    const triggerElement = React.cloneElement(trigger, {
      onMouseEnter: this.handleMouseEnter,
      onMouseLeave: this.handleMouseLeave,
      onClick: this.handleClick
    })
    const tipClassName = classNames(styles.toolTip, styles[style.position])

    return (
      <div className={className || styles.toolTipWrapper}>
        {triggerElement}
        <TransitionGroup>
          {this.state.active &&
          <CSSTransition
            key={triggerElement}
            classNames={{
              enter: styles.tooltipEnter,
              enterActive: styles.tooltipEnterActive,
              exit: styles.tooltipLeave,
              exitActive: styles.tooltipLeaveActive
            }}
            timeout={{
              enter: 500,
              exit: 300
            }}
          >
            <div
              className={tipClassName}
              style={{
                width: style.width,
                transform: style.position === 'topCenter' ? `translateX(-${parseInt(style.width, 10) / 2}px)` : null
              }}
            >
              {children}
            </div>
          </CSSTransition>
          }
        </TransitionGroup>
      </div>
    )
  }

  handleClick () {
    this.toggle()
  }

  toggle () {
    if (!this.state.active) {
      if (this.props.trackingObject) {
        dataLayer.push(this.props.trackingObject)
      }
    }
    this.setState({
      active: !this.state.active
    })
  }

  handleMouseEnter () {
    this.setState({ active: true })
    if (this.props.trackingObject) {
      dataLayer.push(this.props.trackingObject)
    }
  }

  handleMouseLeave () {
    this.setState({ active: false })
  }
}

Tooltip.propTypes = {
  trigger: PropTypes.element.isRequired,
  children: PropTypes.string.isRequired,
  style: PropTypes.shape({
    position: PropTypes.oneOf(['topLeft', 'topRight', 'topCenter']),
    width: PropTypes.string
  }),
  trackingObject: PropTypes.object,
  className: PropTypes.string
}

Tooltip.defaultProps = {
  style: {
    position: 'topLeft',
    width: '260px'
  },
  trackingObject: null,
  className: null
}

export default Tooltip
